// extracted by mini-css-extract-plugin
module.exports = {"root":"Inserate_root__wBRBU","lastUpdated":"Inserate_lastUpdated__mINHl","nonNumberedList":"Inserate_nonNumberedList__3rKnW"};